import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { MODULE_TIMECARDS } from "variables/modules";
import TimecardUpdateRequests from "./index";

const timecardUpdateRequestRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Timecard Update Request",
		basePath: "timecard-update-requests",
		mainComponent: <TimecardUpdateRequests />,
	    layout: "/console",	   
	    subTitle:"Timecard Update Request",
	    // viewComponent: <ViewTimeCard />,
	    // createComponent: <EditTimeCard />,
	    // editComponent: <EditTimeCard />,
		level:3,
		moduleId: MODULE_TIMECARDS,
	})
]

export default timecardUpdateRequestRoutes;